import React from "react";
import { useTranslation } from "react-i18next";
import { DigitalDriverSettingsModel } from "@shared/ui";

interface IControllersSettingsProps {
  settings: DigitalDriverSettingsModel | undefined;
  saveDriverSettings: (
    key: keyof DigitalDriverSettingsModel,
    value: string,
  ) => void;
}

const ControllersSettings: React.FC<IControllersSettingsProps> = ({
  settings,
  saveDriverSettings,
}) => {
  const { t } = useTranslation();
  return (
    <div className="p-20">
      <div className="form-wrapper settings-form">
        <div className="input-wrapper">
          <label>{t("controllersSettings.labels.rightBackward")}</label>
          <input
            type="text"
            onChange={(e) =>
              saveDriverSettings("rightBackwardUs", e.target.value)
            }
            value={settings?.rightBackwardUs}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("controllersSettings.labels.rightStop")}</label>
          <input
            type="text"
            onChange={(e) => saveDriverSettings("rightStopUs", e.target.value)}
            value={settings?.rightStopUs}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("controllersSettings.labels.rightForward")}</label>
          <input
            type="text"
            onChange={(e) =>
              saveDriverSettings("rightForwardUs", e.target.value)
            }
            value={settings?.rightForwardUs}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("controllersSettings.labels.leftBackward")}</label>
          <input
            type="text"
            onChange={(e) =>
              saveDriverSettings("leftBackwardUs", e.target.value)
            }
            value={settings?.leftBackwardUs}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("controllersSettings.labels.leftStop")}</label>
          <input
            type="text"
            onChange={(e) => saveDriverSettings("leftStopUs", e.target.value)}
            value={settings?.leftStopUs}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("controllersSettings.labels.leftForward")}</label>
          <input
            type="text"
            onChange={(e) =>
              saveDriverSettings("leftForwardUs", e.target.value)
            }
            value={settings?.leftForwardUs}
          />
        </div>
      </div>
    </div>
  );
};
export default ControllersSettings;
